import "./SignUpThankYou.css";
import Slide from '@mui/material/Slide';
import SignInNavBarBack from "components/layout/navigation/SignInNavBarBack/SignInNavBarBack";
import {Box} from "@mui/material";
import BenevvButton from "components/buttons/BenevvButton/BenevvButton";
import {useDispatch} from "react-redux";
import {updateSignUpScreen} from "store/ui/signUpScreen/signUpScreen.slice";

interface SignUpThankYouProps {
  userType: UserType
}

function SignUpThankYou(props: SignUpThankYouProps) {
  const {userType} = props;

  const dispatch = useDispatch();

  return (
    <div className={'sign-up-right-container'}>
      <SignInNavBarBack screen={''}/>
      <Slide direction="left" in={true} mountOnEnter unmountOnExit>
        <Box className={"sign-up-thank-you-box"}>
          <div className={'sign-up-thank-you-wrapper'}>
            <div className={'sign-up-thank-you-container'}>
              <div className={'sign-up-thank-you'}>
                <h1> Benevv for {userType.for} </h1>
                <p>
                  Thank you for using Benevv!
                  <br/> <br/>
                  To be added as a <b> {userType.brand} </b> you will be asked to send us your basic info and then a member from our team will reach
                  out within 1 business day to validate and set your account up.
                  <br/> <br/>
                  In the meantime, feel free to sign up as a volunteer to explore the possibilities!
                </p>
              </div>

              <BenevvButton text={`Continue as a ${userType.brand}`} onClick={() => dispatch(updateSignUpScreen('SignUpCreateAccountScreen'))}/>
            </div>
          </div>
        </Box>
      </Slide>
    </div>
  )
}

export default SignUpThankYou;
